var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext } from 'react';
import Brushaway from '@components/Brushaway';
import I18n, { translate } from '@utils/i18n';
import { GenericEventType } from '@features/Calendar/constants';
import { useForm, FormProvider } from 'react-hook-form';
import { TimeZoneContext } from '@contexts/timezone-context';
import { convertUTCToLocalDate } from '@utils/dateUtils';
import { DateTime } from 'luxon';
import { dateClient } from '@utils/date-client';
import { NewGenericEventModalContext } from '../NewGenericEventModalContext';
import { RecurrenceFrequency, RecurrenceDayOfMonthOption, RecurrenceEndType } from '../constants';
import BasicInformationSection from './BasicInformationSection';
import DetailsSection from './DetailsSection';
import AdvancedSection from './AdvancedSection';
function NewGenericEventModal(params) {
    const namespace = 'features.modals.new_generic_event_modal';
    const { closeModal, postGenericEvent } = useContext(NewGenericEventModalContext);
    const { timezone, timeZonesMapping } = useContext(TimeZoneContext);
    const currentDate = dateClient(convertUTCToLocalDate(DateTime.now().setZone(timeZonesMapping[timezone]).toUTC().toString(), timeZonesMapping[timezone]) || new Date());
    const useFormMethods = useForm({
        mode: 'onChange',
        defaultValues: {
            title: '',
            description: '',
            address: '',
            contactName: '',
            contactPhone: '',
            eventType: params.eventType || GenericEventType.On_call,
            durationMins: 120,
            technicianIds: [],
            timeZone: Object.fromEntries(Object.entries(timeZonesMapping).map((entry) => entry.reverse()))[timezone],
            start: currentDate,
            end: currentDate.endOf('day'),
            allDay: false,
            conflictable: true,
            isRecurring: false,
            recurrence: {
                frequency: RecurrenceFrequency.Daily,
                dayOfWeek: 'monday',
                dayOfMonthOption: RecurrenceDayOfMonthOption.First_day,
                dayOfMonth: 2,
                annualDate: currentDate,
                endType: RecurrenceEndType.On_date,
                maxOccurrences: 1,
                endDate: currentDate,
                generateAtOnce: true
            }
        }
    });
    const { getValues, formState: { isValid } } = useFormMethods;
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        return postGenericEvent(getValues())
            .then(() => {
            return true;
        })
            .catch(() => {
            return false;
        });
    });
    return (React.createElement(FormProvider, Object.assign({}, useFormMethods),
        React.createElement(Brushaway, { title: translate('title', { namespace }), open: true, onClose: closeModal, isForm: true, submitButtonText: I18n.t('components.brushaway.create'), onSubmit: handleSubmitForm, isValid: isValid },
            React.createElement("div", { className: "dialog__contain genericEventForm" },
                React.createElement(BasicInformationSection, null),
                React.createElement("hr", { className: "dialog__split splitSections" }),
                React.createElement(DetailsSection, null),
                React.createElement("hr", { className: "dialog__split splitSections" }),
                React.createElement(AdvancedSection, null)))));
}
export default NewGenericEventModal;
